var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 85,
    width: 85,
    xmlns: "http://www.w3.org/2000/svg",
    id: "Cancel",
    x: 400,
    y: 10,
    viewBox: "0 0 29 29",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.339 5.661C18.457.779 10.543.779 5.661 5.661s-4.882 12.796 0 17.678 12.796 4.882 17.678 0 4.881-12.796 0-17.678zm-3.536 12.728a.999.999 0 1 1-1.414 1.414L14.5 15.914l-3.889 3.889a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l3.889-3.889-3.889-3.889a.999.999 0 1 1 1.414-1.414l3.889 3.889 3.889-3.889a.999.999 0 1 1 1.414 1.414L15.914 14.5l3.889 3.889z",
    fill: "#F15B24",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.7cdac61bd0700dc9e0616947450cdee8.svg";
export { ForwardRef as ReactComponent };